






































import { Vue, Prop, Watch } from 'vue-property-decorator'
import Component from 'vue-class-component'
import Delivery from '@/dto/deliveries/Delivery'
import { Routes } from '@/router/routes'
import DictionariesService from '@/services/DictionariesService'
import PopupMenu from '@/components/deliveries/PopupMenu.vue'

@Component({
  components: { PopupMenu },
})
export default class DeliveriesTableRow extends Vue {
  @Prop(Object)
  public delivery: Delivery

  @Prop(Object)
  public props: any

  showDelivery() {
    const deliveryId = this.delivery.id as number

    if (this.$route.params.deliveryId !== deliveryId.toString())
      this.$router.push({
        name: Routes.deliveryEdit,
        params: { deliveryId: deliveryId.toString() },
      })
  }

  get deliveryTypeLabel() {
    return DictionariesService.getDeliveryTypeLabel(this.delivery.type)
  }

  get calculatorTypeLabel() {
    if (this.delivery.printableDeliveryType) {
      return this.delivery.printableDeliveryType
    }

    return DictionariesService.getCalculatorTypeLabel(
      this.delivery.calculatorType
    )
  }
}
